import React, { useContext, useEffect, useState } from 'react';
import Col from 'react-bootstrap/esm/Col';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/esm/Row';
import {
  CurrencyContext,
  CurrentCurrencyContext,
  DepartDataContext,
  ReturnDataContext,
  VoucherCodeContext,
  VoucherDiscountContext,
} from '../UserContext';
import {
  checkIsSgdTrip,
  getMonetaryUnitBasedOnCurrency,
  changeDateFormatToDateTime,
  changeDateFormatToWeekDayMonth,
  getAMorPMonTime,
  getEstimateTimeDurationInHours,
  getNextDay,
  getSubPlaceShortName,
  getToken,
  getYYYYMMDDtwoDigit,
  tokenIsValid,
  checkIncludeReturnTripTicketPlaceBySubPlaceId,
  getMonetaryUnitText,
  sessionStorageGetItem,
  sessionStorageSetItem,
} from './Function';

import './SelectDepartureAndReturn.css';

import { LoadingScreenModal } from './LoadingScreenModal';
import { MoreDetailsPopOutModal } from './MoreDetailsPopOutModal';
import { SelectedOneWayTripModal } from './SelectedOneWayTripModal';
import { SelectedTripSummaryModal } from './SelectedTripSummaryModal';
import { useSearchParams } from 'react-router-dom';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo } from '@fortawesome/free-solid-svg-icons';

export const SelectDepartureAndReturn = ({
  title,
  link,

  depart,
  destination,
  handleSelectedDateCallBack,

  data,
  dateDetail,
  // depart_info,

  // origin_subplace_unique_shortname,
  // destination_subplace_unique_shortname,

  date_depart,
  date_return,
  passenger,
}) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const currency = sessionStorageGetItem('currency');
  const [searchParams, setSearchParams] = useSearchParams();
  const request_id = searchParams.get('request_id') ?? '';
  const { exchangeCurrency, setExchangeCurrency } = useContext(CurrencyContext);

  const [DepartTrip, setDepartTrip] = useState(null);
  const [DestinationTrip, setDestinationTrip] = useState(null);

  // const [data, setData] = useState(null);
  // const [dateDetail, setDateDetail] = useState(null);

  const showBanner =
    (depart.placeuniqueshortname === 'jbsentral' ||
      depart.placeuniqueshortname === 'senaiinternationalairport') &&
    (destination.placeuniqueshortname === 'senaiinternationalairport' ||
      destination.placeuniqueshortname === 'jbsentral');

  const showPremiumBanner =
    (depart.placeuniqueshortname === 'ksl' &&
      destination.placeuniqueshortname === 'berjayatimesquare') ||
    (depart.placeuniqueshortname === 'ksl' &&
      destination.placeuniqueshortname === 'nusentral') ||
    (depart.placeuniqueshortname === 'ksl' &&
      destination.placeuniqueshortname === 'bukitbintang') ||
    (depart.placeuniqueshortname === 'berjayatimesquare' &&
      destination.placeuniqueshortname === 'ksl') ||
    (depart.placeuniqueshortname === 'nusentral' &&
      destination.placeuniqueshortname === 'ksl') ||
    (depart.placeuniqueshortname === 'bukitbintang' &&
      destination.placeuniqueshortname === 'ksl');

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [from_amount, setFromAmount] = useState(0);
  const [dateCounter, setDateCounter] = useState(0);
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(null);
  const [showDetails, setShowDetails] = useState({});
  const [selected_date, setSelectedDate] = useState(getDefaultDate(title));
  const [selected_return_date, setReturnDate] = useState(
    getNextDay(getDefaultDate(title)),
  );

  // const str_depart_info = JSON.stringify(depart_info);
  const { departData, setDepartData } = useContext(DepartDataContext);
  const { returnData, setReturnData } = useContext(ReturnDataContext);
  const { VoucherCode, setVoucherCode } = useContext(VoucherCodeContext);
  const { VoucherDiscount, setVoucherDiscount } = useContext(
    VoucherDiscountContext,
  );

  const { currentCurrency, setCurrentCurrency } = useContext(
    CurrentCurrencyContext,
  );

  const monetary_unit = getMonetaryUnitText(currentCurrency);

  useEffect(() => {
    setVoucherCode(null);
    setVoucherDiscount(0);
    sessionStorageSetItem('voucherDiscountAmount', 0);
  }, []);

  let [subplace_data, setSubPlaceData] = useState([]);

  function getDefaultDate(title) {
    if (title == 'Return') {
      if (date_return !== null && date_return !== 'null') {
        var departData = JSON.parse(sessionStorageGetItem('departData'));
        if (
          new Date(
            changeDateFormatToDateTime(departData.departure_time.split(' ')[0]),
          ) > new Date(changeDateFormatToDateTime(date_return))
        ) {
          return departData.departure_time.split(' ')[0];
        } else {
          return date_return;
        }
      } else return date_depart;
    } else {
      return date_depart;
    }
  }
  function selectedDate(date) {
    var no_trip = false;
    if (dateDetail != null && dateDetail.length != 0) {
      dateDetail.forEach((element) => {
        if (element.travel_date == date && element.no_of_trip == '0') {
          no_trip = true;
        }
      });
    }
    var today = new Date();
    var nextDay = getNextDay(date);

    if (title == 'Return') {
      var departData = JSON.parse(sessionStorageGetItem('departData'));
      today = new Date(
        changeDateFormatToDateTime(departData.departure_time.split(' ')[0]),
      );
    }
    if (new Date(nextDay) > today && no_trip == false) {
      setSelectedDate(getYYYYMMDDtwoDigit(date));
      setReturnDate(getNextDay(date));
      setDateCounter(0);
      handleSelectedDateCallBack(getYYYYMMDDtwoDigit(date));
    }
  }

  let new_date_return = getNextDay(date_return);

  const onHover = (e, index, bus_class) => {
    var hovered_item = null;
    e.preventDefault();
    if (bus_class == 'class') {
      hovered_item = document.getElementById(`hover` + index);
    } else {
      hovered_item = document.getElementById(`eta` + index);
    }
    hovered_item.classList.remove('hidden');
  };

  const onHoverOver = (e, index, bus_class) => {
    var hovered_item = null;
    e.preventDefault();
    if (bus_class == 'class') {
      hovered_item = document.getElementById(`hover` + index);
    } else {
      hovered_item = document.getElementById(`eta` + index);
    }
    hovered_item.classList.add('hidden');
  };

  function checkBusClass(TotalSeat) {
    if (TotalSeat <= 30) {
      return 'Standard';
    } else return 'Executive';
  }

  function getBusImage(bus_class) {
    if (bus_class == 'Standard') {
      return './images/bus/standard.jpg';
    } else return './images/bus/double_decker.jpeg';
  }
  // console.log(data);
  function checkReturn() {
    const checkReturnData = sessionStorageGetItem('returnData');
    if (checkReturnData !== null) {
      return 'return';
    } else return 'depart';
  }

  function updateSelectedDepartData(
    index,
    DepartureDate,
    bus_class,
    SeatAvailable,
    AdultPrice,
    ChildPrice,
    TripKey,
    PickupAddress,
    DropOffAddress,
    TripDuration,
    TripDurationInSecond,
    DefaultCurrencyAdultPrice,
    DefaultCurrencyChildPrice,

    FromPlaceId,
    FromPlaceDisplayName,
    FromPlaceUniqueShortName,
    FromSubPlaceId,
    FromSubPlaceDisplayName,
    FromSubPlaceDisplayName1,
    FromSubPlaceUniqueShortName,

    ToPlaceId,
    ToPlaceDisplayName,
    ToPlaceUniqueShortName,
    ToSubPlaceId,
    ToSubPlaceDisplayName,
    ToSubPlaceDisplayName1,
    ToSubPlaceUniqueShortName,

    ShuttleBusTripKey,
    RouteId,
    TripDate,
    TripTime,
    TripNo,
    Operator,
    CompanyId,
    CompanyName,
    CoachId,
    CoachNumber,
  ) {
    // When a departure trip is selected, update the origin and destination data.
    // Note: the exact subplace ID may not be available, as the user might select a general location
    // such as "Johor (All Locations)", making it difficult to determine the specific subplace ID.

    sessionStorageSetItem(
      'Origin_data',
      JSON.stringify({
        placeid: FromPlaceId,
        placename: FromPlaceDisplayName,
        placedisplayname: FromPlaceDisplayName,
        placeuniqueshortname: FromPlaceUniqueShortName,

        subplaceid: FromSubPlaceId,
        subplacename: FromSubPlaceDisplayName,
        subplaceuniqueshortname: FromSubPlaceUniqueShortName,
        subplacedisplayname1: FromSubPlaceDisplayName1,
        subplacedisplayname: FromSubPlaceDisplayName,
      }),
    );
    sessionStorageSetItem(
      'Destination_data',
      JSON.stringify({
        placeid: ToPlaceId,
        placename: ToPlaceDisplayName,
        placedisplayname: ToPlaceDisplayName,
        placeuniqueshortname: ToPlaceUniqueShortName,

        subplaceid: ToSubPlaceId,
        subplacename: ToSubPlaceDisplayName,
        subplaceuniqueshortname: ToSubPlaceUniqueShortName,
        subplacedisplayname1: ToSubPlaceDisplayName1,
        subplacedisplayname: ToSubPlaceDisplayName,
      }),
    );

    if (ShuttleBusTripKey) {
      sessionStorageSetItem(
        'departDataMultiModal',
        JSON.stringify({
          departure_time: DepartureDate,
          class: bus_class,
          vacancy: SeatAvailable,
          fare: 0,
          child_fare: 0,
          TripKey: ShuttleBusTripKey,
          depart_from: depart.subplacename,
          depart_to: destination.subplacename,
          pick_up: PickupAddress,
          drop_off: DropOffAddress,
          duration: TripDuration,
          duration_in_seconds: TripDurationInSecond,
          adultPriceInSgd: 0,
          childPriceInSgd: 0,
        }),
      );
    }

    if (checkIsSgdTrip()) {
      sessionStorageSetItem(
        'departData',
        JSON.stringify({
          departure_time: DepartureDate,
          class: bus_class,
          vacancy: SeatAvailable,
          fare: AdultPrice,
          child_fare: ChildPrice,

          TripKey: TripKey,
          ShuttleBusTripKey: ShuttleBusTripKey,

          depart_from: FromSubPlaceDisplayName,
          depart_to: ToSubPlaceDisplayName,

          depart_place_name: FromPlaceDisplayName,
          arrival_place_name: ToPlaceDisplayName,

          pick_up: PickupAddress,
          drop_off: DropOffAddress,

          duration: TripDuration,
          duration_in_seconds: TripDurationInSecond,
          adultPriceInSgd: DefaultCurrencyAdultPrice,
          childPriceInSgd: DefaultCurrencyChildPrice,
          routeId: RouteId,
          tripDate: TripDate,
          tripTime: TripTime,
          tripNo: TripNo,
          operator: Operator,
          companyId: CompanyId,
          companyName: CompanyName,
          coachId: CoachId,
          coachNumber: CoachNumber,
        }),
      );
    } else {
      sessionStorageSetItem(
        'departData',
        JSON.stringify({
          departure_time: DepartureDate,
          class: bus_class,
          vacancy: SeatAvailable,
          fare: AdultPrice,
          child_fare: ChildPrice,

          TripKey: TripKey,
          ShuttleBusTripKey: ShuttleBusTripKey,

          depart_from: FromSubPlaceDisplayName,
          depart_to: ToSubPlaceDisplayName,

          depart_place_name: FromPlaceDisplayName,
          arrival_place_name: ToPlaceDisplayName,

          pick_up: PickupAddress,
          drop_off: DropOffAddress,

          duration: TripDuration,
          duration_in_seconds: TripDurationInSecond,
          adultPriceInSgd: DefaultCurrencyAdultPrice,
          childPriceInSgd: DefaultCurrencyChildPrice,

          routeId: RouteId,
          tripDate: TripDate,
          tripTime: TripTime,
          tripNo: TripNo,
          operator: Operator,
          companyId: CompanyId,
          companyName: CompanyName,
          coachId: CoachId,
          coachNumber: CoachNumber,
        }),
      );
    }

    if (RouteId && RouteId.startsWith('UA')) {
      const passengerCount = parseInt(passenger || '1', 10);
      const defaultSeats = [];
      for (let i = 0; i < passengerCount; i++) {
        defaultSeats.push({
          SeatNumber: 'Free Seating',
          DisplayCode: 'Free Seating',
          SeatDeck: '1',
          SeatId: 0,
          SeatCode: 'Free Seating',
        });
      }

      sessionStorageSetItem(
        'selectedDepartSeat',
        JSON.stringify(defaultSeats)
      );
      sessionStorageSetItem('selectedReturnSeat', JSON.stringify([]));

      const defaultFare = AdultPrice * passengerCount;
      sessionStorageSetItem('busFare', JSON.stringify(defaultFare));
      sessionStorageSetItem('addOn', JSON.stringify(0));
      sessionStorageSetItem('depart_TripKey', JSON.stringify(TripKey));
      sessionStorage.removeItem('return_TripKey');

      const originData = JSON.parse(sessionStorageGetItem('Origin_data'));
      const destinationData = JSON.parse(
        sessionStorageGetItem('Destination_data')
      );

      window.location.href = `/checkout?depart=${
        originData.subplaceuniqueshortname || originData.placeuniqueshortname
      }&destination=${
        destinationData.subplaceuniqueshortname ||
        destinationData.placeuniqueshortname
      }&depart_date=${
        DepartureDate.split(' ')[0]
      }&return_date=null&passenger=${passenger}&request_id=${
        searchParams.get('request_id') ?? ''
      }`;
      return;
    }

    if (depart.Reschedule == true && depart.ReturnDate == 'null') {
      window.location.href = '/selectSeat';
    } else if (depart.Reschedule == true && depart.ReturnDate != 'null') {
      window.location.href = '/pickReturn';
    } else {
      const originData = JSON.parse(sessionStorageGetItem('Origin_data'));
      const destinationData = JSON.parse(
        sessionStorageGetItem('Destination_data'),
      );

      if (checkIncludeReturnTripTicketPlaceBySubPlaceId(ToSubPlaceId) == true) {
        window.location.href = `/selectSeat?depart=${
          originData.subplaceuniqueshortname || originData.placeuniqueshortname
        }&destination=${
          destinationData.subplaceuniqueshortname ||
          destinationData.placeuniqueshortname
        }&depart_date=${
          DepartureDate.split(' ')[0]
        }&return_date=null&passenger=${passenger}&request_id=${request_id}`;
      } else if (date_return !== 'null') {
        window.location.href = `/pickReturn?depart=${
          originData.subplaceuniqueshortname || originData.placeuniqueshortname
        }&destination=${
          destinationData.subplaceuniqueshortname ||
          destinationData.placeuniqueshortname
        }&depart_date=${
          DepartureDate.split(' ')[0]
        }&return_date=${date_return}&passenger=${passenger}&request_id=${request_id}`;
      } else {
        const id = `button${index}`;
        var element = document.getElementById(id);
        element.innerHTML =
          "<img src='/images/ic_selected.png' alt='selected'/> Selected";
        element.classList.add('selected');

        //reassign complete session storage data to modal
        const originData = JSON.parse(sessionStorageGetItem('Origin_data'));
        const destinationData = JSON.parse(
          sessionStorageGetItem('Destination_data'),
        );
        setDepartTrip(originData);
        setDestinationTrip(destinationData);

        if (
          !originData.subplacedisplayname1.includes('Shuttle Bus') &&
          !destinationData.subplacedisplayname1.includes('Shuttle Bus')
        ) {
          setShow1(true);
        } else {
          const departData = JSON.parse(sessionStorageGetItem('departData'));

          window.location.href = `/selectSeat?depart=${
            originData.subplaceuniqueshortname
          }&destination=${
            destinationData.subplaceuniqueshortname
          }&depart_date=${moment(departData.departure_time).format(
            'YYYY-MM-DD',
          )}&return_date=null&passenger=${passenger}&request_id=${
            searchParams.get('request_id') ?? ''
          }`;
        }
      }
    }
  }
  // console.log(departData);

  function updateSelectedReturnData(
    index,
    DepartureDate,
    bus_class,
    SeatAvailable,
    AdultPrice,
    ChildPrice,
    TripKey,
    PickupAddress,
    DropOffAddress,
    TripDuration,
    TripDurationInSecond,
    DefaultCurrencyAdultPrice,
    DefaultCurrencyChildPrice,

    FromPlaceDisplayName,
    ToPlaceDisplayName,

    FromSubPlaceDisplayName,
    ToSubPlaceDisplayName,

    RouteId,
    TripDate,
    TripTime,
    TripNo,
    Operator,
    CompanyId,
    CompanyName,
    CoachId,
    CoachNumber,
  ) {
    const departData = JSON.parse(sessionStorageGetItem('departData'));

    if (DepartureDate < departData.departure_time) {
      alert('Return trip cannot be earlier than depart trip');
      return;
    }

    if (checkIsSgdTrip()) {
      sessionStorageSetItem(
        'returnData',
        JSON.stringify({
          departure_time: DepartureDate,
          class: bus_class,
          vacancy: SeatAvailable,
          fare: AdultPrice,
          child_fare: ChildPrice,
          TripKey: TripKey,

          depart_from: FromSubPlaceDisplayName,
          depart_to: ToSubPlaceDisplayName,

          depart_place_name: FromPlaceDisplayName,
          arrival_place_name: ToPlaceDisplayName,

          pick_up: PickupAddress,
          drop_off: DropOffAddress,

          duration: TripDuration,
          duration_in_seconds: TripDurationInSecond,
          adultPriceInSgd: DefaultCurrencyAdultPrice,
          childPriceInSgd: DefaultCurrencyChildPrice,

          routeId: RouteId,
          tripDate: TripDate,
          tripTime: TripTime,
          tripNo: TripNo,
          operator: Operator,
          companyId: CompanyId,
          companyName: CompanyName,
          coachId: CoachId,
          coachNumber: CoachNumber,
        }),
      );
    } else {
      sessionStorageSetItem(
        'returnData',
        JSON.stringify({
          departure_time: DepartureDate,
          class: bus_class,
          vacancy: SeatAvailable,
          fare: AdultPrice,
          child_fare: ChildPrice,
          TripKey: TripKey,

          depart_from: destination.subplacename,
          depart_to: depart.subplacename,

          depart_place_name: FromPlaceDisplayName,
          arrival_place_name: ToPlaceDisplayName,

          pick_up: PickupAddress,
          drop_off: DropOffAddress,

          duration: TripDuration,
          duration_in_seconds: TripDurationInSecond,
          adultPriceInSgd: DefaultCurrencyAdultPrice,
          childPriceInSgd: DefaultCurrencyChildPrice,

          routeId: RouteId,
          tripDate: TripDate,
          tripTime: TripTime,
          tripNo: TripNo,
          operator: Operator,
          companyId: CompanyId,
          companyName: CompanyName,
          coachId: CoachId,
          coachNumber: CoachNumber,
        }),
      );
    }
    const id = `button${index}`;
    var element = document.getElementById(id);
    element.innerHTML =
      "<img src='/images/ic_selected.png' alt='selected'/> Selected";
    element.classList.add('selected');
    setShow(true);
  }
  // console.log(returnData);
  function showMoreDetails(
    currency,
    PickupAddress,
    DropOffAddress,
    DepartureDate,
    AdultPrice,
    ChildPrice,
    TripDurationInSecond,
    CoachType,
  ) {
    setShow2(!show2);
    setShowDetails({
      pickupaddress: PickupAddress,
      dropoffaddress: DropOffAddress,
      departuredate: DepartureDate,
      currency: currency,
      adultprice: AdultPrice,
      childprice: ChildPrice,
      durationinseconds: TripDurationInSecond,
      coachtype: CoachType,
    });
  }

  useEffect(() => {
    if (show2 == false) {
      setShow2(true);
    }
  }, [show2 === false]);

  // console.log(dateDetail)
  function getDateClassName(date) {
    var today = new Date();
    var no_trip = false;
    // console.log((date));
    // console.log(new Date(date));
    // console.log(today);
    var nextDay = getNextDay(date);
    if (title == 'Return') {
      var departData = JSON.parse(sessionStorageGetItem('departData'));
      // console.log(departData.departure_time.split(" ")[0])
      // console.log(new Date((changeDateFormatToDateTime(departData.departure_time.split(" ")[0]))));
      today = new Date(
        changeDateFormatToDateTime(departData.departure_time.split(' ')[0]),
      );
      // console.log(today)
    }
    // console.log(changeDateFormatToDateTime(nextDay))
    // console.log(new Date(nextDay))
    // console.log(new Date(changeDateFormatToDateTime(nextDay)));

    if (dateDetail != null && dateDetail.length != 0) {
      dateDetail.forEach((element) => {
        // console.log(element)
        if (element.travel_date == date && element.no_of_trip == '0') {
          no_trip = true;
        }
      });
    }
    if (selected_date == date) {
      return 'pick_date_box date_selected';
    } else if (
      new Date(changeDateFormatToDateTime(nextDay)) <= today ||
      no_trip == true
    ) {
      return 'pick_date_box date_inactive';
    } else {
      return 'pick_date_box';
    }
  }

  if (data !== null) {
    var lowest = 1000;

    // if (title == 'Return') {
    //     data.forEach(element => {
    //         if (element.FromSubPlaceId === destination.SubPlaceId
    //             && element.ToSubPlaceId === depart.SubPlaceId
    //             //&& element.CompanyName.includes("Causeway Link")
    //         ) {
    //             subplace_data = subplace_data.concat(element);
    //             if (element.AdultPrice < lowest) {
    //                 lowest = element.AdultPrice.toFixed(2);
    //             }
    //         }
    //     });
    // }
    // else {
    //     data.forEach(element => {

    //         // console.log(element.FromSubPlaceId + ' vs ' + depart.SubPlaceId + ' && ' + element.ToSubPlaceId + ' vs ' + destination.SubPlaceId);

    //         if (element.FromSubPlaceId === depart.SubPlaceId
    //             && element.ToSubPlaceId === destination.SubPlaceId
    //             // && element.CompanyName.includes("Causeway Link")
    //         ) {
    //             subplace_data = subplace_data.concat(element);
    //             if (element.AdultPrice < lowest) {
    //                 lowest = element.AdultPrice.toFixed(2);
    //             }
    //         }
    //     });
    // }
  }

  function getLowestAmount(date, lowest) {
    if (dateDetail != null && dateDetail.length != 0) {
      dateDetail.forEach((element) => {
        if (element.travel_date.toString() === date.toString()) {
          lowest = element.lowest_price;
        }
      });
      return lowest == 1000 ? 0.0 : lowest;
    } else {
      return lowest == 1000 ? 0.0 : lowest;
    }
  }

  const [activeDepartStops, setActiveDepartStops] = useState([]);
  const [activeArrivalStops, setActiveArrivalStops] = useState([]);
  const [activeTimeFilters, setActiveTimeFilters] = useState([]); // 'Morning', 'Afternoon', 'Evening'

  const allDepartStops = Array.from(
    new Set(data?.map((item) => item.pickupaddress) || []),
  );
  const allArrivalStops = Array.from(
    new Set(data?.map((item) => item.dropoffaddress) || []),
  );

  const toggleDepartStop = (stop) => {
    setActiveDepartStops((prev) =>
      prev.includes(stop) ? prev.filter((s) => s !== stop) : [...prev, stop],
    );
  };

  const toggleArrivalStop = (stop) => {
    setActiveArrivalStops((prev) =>
      prev.includes(stop) ? prev.filter((s) => s !== stop) : [...prev, stop],
    );
  };

  const toggleTimeFilter = (time) => {
    setActiveTimeFilters((prev) =>
      prev.includes(time) ? prev.filter((t) => t !== time) : [...prev, time],
    );
  };

  // Filter data before rendering
  const filteredData = data?.filter((item) => {
    // Stop Filtering
    const departMatch =
      activeDepartStops.length === 0 ||
      activeDepartStops.includes(item.pickupaddress);
    const arrivalMatch =
      activeArrivalStops.length === 0 ||
      activeArrivalStops.includes(item.dropoffaddress);

    // Time Filtering
    let timeMatch = true;
    if (activeTimeFilters.length > 0) {
      const timeString =
        item.shuttlebustriptime || item.departuredate.split(' ')[1]; // "HH:mm:ss"
      const hour = parseInt(timeString.split(':')[0], 10);
      let period = '';

      if (hour >= 5 && hour < 12) period = 'Morning';
      else if (hour >= 12 && hour < 18) period = 'Afternoon';
      else period = 'Evening';

      timeMatch = activeTimeFilters.includes(period);
    }

    return departMatch && arrivalMatch && timeMatch;
  });

  useEffect(() => {
    const elements = document.querySelectorAll('.trips_button');

    // Loop through and set innerHTML
    elements.forEach((el) => {
      el.innerHTML = 'Select';
      el.classList.remove('selected');
    });
  }, []);

  return (
    <>
      {show ? (
        <SelectedTripSummaryModal
          title={title}
          // depart={destination.subplaceuniqueshortname}
          // destination={depart.subplaceuniqueshortname}
          depart={
            DestinationTrip?.subplaceuniqueshortname ??
            destination.subplaceuniqueshortname
          }
          destination={
            DepartTrip?.subplaceuniqueshortname ??
            depart.subplaceuniqueshortname
          }
          passenger={passenger}
        />
      ) : (
        ''
      )}
      {show1 ? (
        <SelectedOneWayTripModal
          depart={
            DepartTrip?.subplaceuniqueshortname ??
            depart.subplaceuniqueshortname
          }
          destination={
            DestinationTrip?.subplaceuniqueshortname ??
            destination.subplaceuniqueshortname
          }
          passenger={passenger}
        />
      ) : (
        // <SelectedOneWayTripModal
        // 	depart={depart.subplaceuniqueshortname}
        // 	destination={destination.subplaceuniqueshortname}
        // 	passenger={passenger}
        // />
        ''
      )}
      {show2 ? (
        <MoreDetailsPopOutModal
          title={title}
          depart={depart.subplacename}
          destination={destination.subplacename}
          details={showDetails}
        />
      ) : (
        ''
      )}

      <Container>
        {showPremiumBanner ? (
          <div style={{ marginTop: '50px' }} className='premium-banner'>
            <a
              href='https://www.causewaylink.com.my/causeway-link-express-premium/?utm_source=google&utm_medium=Landing+Page+Causeway+Link+Express+Premium+Booking+Site&utm_campaign=CWLExpress_Sale'
              target='_blank'
            >
              <img
                style={{ width: '100%' }}
                alt='premium-bus-banner'
                src='images/Web-Banner-Causeway-Link-Express-Premium-More-Info-01.png'
              />
            </a>
          </div>
        ) : (
          ''
        )}
        <div className='upcoming-booking-container'>
          <div className='table-container'>
            <Row className='clear-margin'>
              <div className='background-blue departReturn_header'>
                <Row>
                  <Col xs={5} sm={5} className='hide-on-mobile'>
                    <h1>Select your {title}</h1>
                  </Col>
                  <Col xs={12} sm={7}>
                    {title === 'Departure' ? (
                      <h3>
                        {depart.subplacename || depart.placename}{' '}
                        <img src='images/ic_to.png' alt='to' />{' '}
                        {destination.subplacename || destination.placename}
                      </h3>
                    ) : (
                      <h3>
                        {destination.subplacename || destination.placename}{' '}
                        <img src='images/ic_to.png' alt='to' />{' '}
                        {depart.subplacename || depart.placename}
                      </h3>
                    )}
                  </Col>
                </Row>
              </div>
              <div className='background-yellow' />
            </Row>
            <Row>
              <div className='date_select_container'>
                <table width={'100%'} className='date_items_center'>
                  <tr>
                    <td>
                      <img
                        src='images/ic_left.png'
                        alt='left'
                        onClick={() => setDateCounter(dateCounter - 1)}
                      />
                    </td>

                    <td>
                      <div
                        className={
                          getDateClassName(
                            getNextDay(selected_date, dateCounter - 3),
                          ) + ' hidden-768'
                        }
                        onClick={() =>
                          selectedDate(
                            getNextDay(selected_date, dateCounter - 3),
                          )
                        }
                      >
                        <h4>
                          {changeDateFormatToWeekDayMonth(
                            getNextDay(selected_date, dateCounter - 3),
                          )}
                        </h4>
                        {/* <h5>From {monetary_unit} {getLowestAmount(getNextDay(selected_date, dateCounter - 3), lowest)}</h5> */}
                        {/* <h6>LOWEST!</h6> */}
                      </div>
                    </td>
                    <td>
                      <div
                        className={
                          getDateClassName(
                            getNextDay(selected_date, dateCounter - 2),
                          ) + ' hidden-547'
                        }
                        onClick={() =>
                          selectedDate(
                            getNextDay(selected_date, dateCounter - 2),
                          )
                        }
                      >
                        <h4>
                          {changeDateFormatToWeekDayMonth(
                            getNextDay(selected_date, dateCounter - 2),
                          )}
                        </h4>
                        {/* <h5>From {monetary_unit} {getLowestAmount(getNextDay(selected_date, dateCounter - 2), lowest)}</h5> */}
                        {/* <h6>LOWEST!</h6> */}
                      </div>
                    </td>
                    <td>
                      <div
                        className={getDateClassName(
                          getNextDay(selected_date, dateCounter - 1),
                        )}
                        onClick={() =>
                          selectedDate(
                            getNextDay(selected_date, dateCounter - 1),
                          )
                        }
                      >
                        <h4>
                          {changeDateFormatToWeekDayMonth(
                            getNextDay(selected_date, dateCounter - 1),
                          )}
                        </h4>
                        {/* <h5>From {monetary_unit} {getLowestAmount(getNextDay(selected_date, dateCounter - 1), lowest)}</h5> */}
                        {/* <h6>LOWEST!</h6> */}
                      </div>
                    </td>
                    <td>
                      <div
                        className={getDateClassName(
                          getNextDay(selected_date, dateCounter),
                        )}
                        onClick={() =>
                          selectedDate(getNextDay(selected_date, dateCounter))
                        }
                      >
                        <h4>
                          {changeDateFormatToWeekDayMonth(
                            getNextDay(selected_date, dateCounter),
                          )}
                        </h4>
                        {/* <h5>From {monetary_unit} {getLowestAmount(getNextDay(selected_date, dateCounter), lowest)}</h5> */}
                        {/* <h6>LOWEST!</h6> */}
                      </div>
                    </td>
                    <td>
                      <div
                        className={getDateClassName(
                          getNextDay(selected_date, dateCounter + 1),
                        )}
                        onClick={() =>
                          selectedDate(
                            getNextDay(selected_date, dateCounter + 1),
                          )
                        }
                      >
                        <h4>
                          {changeDateFormatToWeekDayMonth(
                            getNextDay(selected_date, dateCounter + 1),
                          )}
                        </h4>
                        {/* <h5>From {monetary_unit} {getLowestAmount(getNextDay(selected_date, dateCounter + 1), lowest)}</h5> */}
                        {/* <h6>LOWEST!</h6> */}
                      </div>
                    </td>
                    <td>
                      <div
                        className={
                          getDateClassName(
                            getNextDay(selected_date, dateCounter + 2),
                          ) + ' hidden-547'
                        }
                        onClick={() =>
                          selectedDate(
                            getNextDay(selected_date, dateCounter + 2),
                          )
                        }
                      >
                        <h4>
                          {changeDateFormatToWeekDayMonth(
                            getNextDay(selected_date, dateCounter + 2),
                          )}
                        </h4>
                        {/* <h5>From {monetary_unit} {getLowestAmount(getNextDay(selected_date, dateCounter + 2), lowest)}</h5> */}
                        {/* <h6>LOWEST!</h6> */}
                      </div>
                    </td>
                    <td>
                      <div
                        className={
                          getDateClassName(
                            getNextDay(selected_date, dateCounter + 3),
                          ) + ' hidden-768'
                        }
                        onClick={() =>
                          selectedDate(
                            getNextDay(selected_date, dateCounter + 3),
                          )
                        }
                      >
                        <h4>
                          {changeDateFormatToWeekDayMonth(
                            getNextDay(selected_date, dateCounter + 3),
                          )}
                        </h4>
                        {/* <h5>From {monetary_unit} {getLowestAmount(getNextDay(selected_date, dateCounter + 3), lowest)}</h5> */}
                        {/* <h6>LOWEST!</h6> */}
                      </div>
                    </td>
                    <td>
                      <img
                        src='images/ic_right.png'
                        alt='right'
                        onClick={() => setDateCounter(dateCounter + 1)}
                      />
                    </td>
                  </tr>
                </table>
              </div>
            </Row>
          </div>

          <Row className='mt-4'>
            {/* Sidebar Filters */}
            <Col lg={3} className='d-none d-lg-block'>
              <div className='filter-sidebar'>
                <div className='filter-title'>
                  <span
                    className='material-symbols-outlined me-2'
                    style={{ color: '#FDB813' }}
                  >
                    filter_list
                  </span>
                  Filters
                </div>

                {/* Time Filter */}
                <div className='filter-group'>
                  <div className='filter-group-title'>Departure Time</div>
                  <div className='filter-options-stack'>
                    {['Morning', 'Afternoon', 'Evening'].map((time) => (
                      <div
                        key={time}
                        className={`filter-option ${activeTimeFilters.includes(time) ? 'active' : ''}`}
                        onClick={() => toggleTimeFilter(time)}
                      >
                        <div
                          className={`filter-checkbox ${activeTimeFilters.includes(time) ? 'bg-warning' : 'bg-white'}`}
                          style={{ border: '1px solid #ccc' }}
                        >
                          {activeTimeFilters.includes(time) && (
                            <span
                              className='material-symbols-outlined'
                              style={{ fontSize: '14px', color: 'black' }}
                            >
                              check
                            </span>
                          )}
                        </div>
                        <div className='filter-label-content'>
                          <div className='filter-label-title'>{time}</div>
                          <div className='filter-label-desc'>
                            {time === 'Morning' && '05:00 AM - 11:59 AM'}
                            {time === 'Afternoon' && '12:00 PM - 05:59 PM'}
                            {time === 'Evening' && '06:00 PM - 04:59 AM'}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Departure Stops Filter */}
                {allDepartStops.length > 1 && (
                  <div className='filter-group'>
                    <div className='filter-group-title'>Departure Stop</div>
                    <div className='d-flex flex-wrap gap-2'>
                      {allDepartStops.map((stop, index) => (
                        <div
                          key={index}
                          className={`filter-chip ${activeDepartStops.includes(stop) ? 'active' : ''}`}
                          onClick={() => toggleDepartStop(stop)}
                        >
                          {activeDepartStops.includes(stop) && (
                            <span
                              className='material-symbols-outlined me-1'
                              style={{ fontSize: '12px' }}
                            >
                              check
                            </span>
                          )}
                          {stop}
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Arrival Stops Filter */}
                {allArrivalStops.length > 1 && (
                  <div className='filter-group'>
                    <div className='filter-group-title'>Arrival Stop</div>
                    <div className='d-flex flex-wrap gap-2'>
                      {allArrivalStops.map((stop, index) => (
                        <div
                          key={index}
                          className={`filter-chip ${activeArrivalStops.includes(stop) ? 'active' : ''}`}
                          onClick={() => toggleArrivalStop(stop)}
                        >
                          {activeArrivalStops.includes(stop) && (
                            <span
                              className='material-symbols-outlined me-1'
                              style={{ fontSize: '12px' }}
                            >
                              check
                            </span>
                          )}
                          {stop}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </Col>

            {/* Main Results */}
            <Col lg={9} md={12}>
              <div className='pick_departure'>
                {loading && (
                  <div className='center'>
                    <LoadingScreenModal />
                  </div>
                )}
                {error && (
                  <div>{`There is a problem fetching the post data - ${error}`}</div>
                )}

                {/* Header for Desktop */}
                {filteredData && filteredData.length > 0 && (
                  <div className='trip-list-header d-none d-md-grid'>
                    <div style={{ gridColumn: 'span 4' }}>Operator & Route</div>
                    <div style={{ gridColumn: 'span 2', textAlign: 'center' }}>
                      Arrival
                    </div>
                    <div style={{ gridColumn: 'span 2', textAlign: 'center' }}>
                      Info
                    </div>
                    <div style={{ gridColumn: 'span 2', textAlign: 'center' }}>
                      Vacancy
                    </div>
                    <div style={{ gridColumn: 'span 2', textAlign: 'right' }}>
                      Fare
                    </div>
                  </div>
                )}

                {filteredData && filteredData.length === 0 ? (
                  <div className='no_bus_trip'>
                    <h3>
                      Looking for Bus from{' '}
                      {title === 'Departure'
                        ? depart.subplacename || depart.placename
                        : destination.subplacename ||
                          destination.placename}{' '}
                      to{' '}
                      {title === 'Departure'
                        ? destination.subplacename || destination.placename
                        : depart.subplacename || depart.placename}{' '}
                      ?
                    </h3>
                    <h6>
                      Sold out or no bus trips found for the date selected.
                      Please try other dates for Bus tickets.
                    </h6>
                  </div>
                ) : (
                  <div className='trip-list-container'>
                    {filteredData &&
                      filteredData.map((item, index) => (
                        <div key={index} className='trip-card'>
                          <div className='trip-card-grid'>
                            {/* Operator & Route Section */}
                            <div className='trip-operator-section'>
                              <div className='operator-logo-box'>
                                <img
                                  src={`images/${item.operator.toLowerCase()}.png`}
                                  alt={item.operator}
                                />
                              </div>
                              <div>
                                <div className='d-flex align-items-center mb-1 gap-2'>
                                  <span className='trip-time-main'>
                                    {item.shuttlebustriptime
                                      ? moment(
                                          item.shuttlebustriptime,
                                          'HH:mm:ss',
                                        ).format('hh:mm A')
                                      : getAMorPMonTime(
                                          item.departuredate.split(' ')[1],
                                        )}
                                  </span>
                                  {(item.coachtype
                                    .toLowerCase()
                                    .includes('comfort') ||
                                    item.coachtype
                                      .toLowerCase()
                                      .includes('premium')) && (
                                    <span className='badge-premium'>
                                      <span
                                        className='material-symbols-outlined'
                                        style={{
                                          fontSize: '10px',
                                          marginRight: '2px',
                                        }}
                                      >
                                        workspace_premium
                                      </span>
                                      PREMIUM
                                    </span>
                                  )}
                                </div>
                                <p className='trip-place-sub mb-0 d-none d-md-block'>
                                  {item.pickupaddress}
                                </p>

                                {/* Mobile only arrival info */}
                                <div className='d-md-none mt-1'>
                                  {/* <p className="trip-place-sub mb-0">{item.pickupaddress}</p>
																	<div className="text-muted small text-center">
																		<span className="material-symbols-outlined" style={{ fontSize: '14px', verticalAlign: 'middle' }}>arrow_downward</span>
																	</div>
																	<p className="trip-place-sub mb-0">{item.dropoffaddress}</p>
																	<div className="text-muted small">
																		{item.shuttlebustriptime
																			? moment(`${item.tripdate} ${item.shuttlebustriptime}`).add(item.tripdurationinsecond, 'seconds').format('hh:mm A')
																			: "" // Ideally calculate arrival time properly
																		}
																	</div> */}
                                  <div className='tailwind-scope'>
                                    <div className='relative py-2 ml-4 mt-2 border-l-2 border-dashed border-r-0 border-t-0 border-b-0 border-slate-200 dark:border-slate-700 space-y-4'>
                                      <div className='relative pl-6'>
                                        <div className='absolute -left-[9px] top-1 w-4 h-4 rounded-full bg-white border-1 border-slate-200'></div>
                                        <div className='text-xs font-medium text-slate-500 '>
                                          Departure
                                        </div>
                                        <div className='text-sm  text-slate-900 '>
                                          {item.pickupaddress}
                                        </div>
                                      </div>
                                      <div className='relative pl-6'>
                                        <div className='absolute -left-[9px] top-0 w-4 h-4 rounded-full bg-white border-0 border-slate-200'>
                                          <span className='material-symbols-outlined text-[#1E3A8A]/70 text-lg'>
                                            location_on
                                          </span>
                                        </div>
                                        <div className='text-xs font-medium text-slate-500 '>
                                          Arrival
                                        </div>
                                        <div className='text-sm font-semibold text-slate-900 '>
                                          {item.dropoffaddress}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Route Visual (Desktop) */}
                            <div className='trip-route-section d-none d-md-block'>
                              <div className='route-arrow-box'>
                                <span
                                  className='material-symbols-outlined'
                                  style={{
                                    fontSize: '14px',
                                    verticalAlign: 'middle',
                                  }}
                                >
                                  arrow_forward
                                </span>
                              </div>
                              {/* <div className="route-line"></div> */}
                              <div>
                                <p
                                  className='trip-place-sub'
                                  style={{ fontWeight: 'bold' }}
                                >
                                  {item.dropoffaddress}
                                </p>
                                {/* <p className="text-muted small mb-0">Arrival Time</p> */}
                              </div>
                            </div>

                            {/* Info Section */}
                            <div className='trip-info-section tailwind-scope'>
                              {item.operator === 'HANDAL' && (
                                <>
                                  <div className='col-span-6 md:col-span-2 text-center'>
                                    <div
                                      className='bg-[#eff6ff] rounded-lg p-2 flex flex-col items-center border border-blue-100 hover:border-blue-300 transition-colors cursor-pointer group'
                                      onClick={() =>
                                        showMoreDetails(
                                          currency,
                                          item.pickupaddress,
                                          item.dropoffaddress,
                                          item.departuredate,
                                          currentCurrency === 'MYR'
                                            ? item.adultprice
                                            : item.adultpriceinsgd || 0,
                                          currentCurrency === 'MYR'
                                            ? item.childprice
                                            : item.childpriceinsgd || 0,
                                          item.tripdurationinsecond,
                                          item.coachtype,
                                        )
                                      }
                                    >
                                      <div className='flex items-center justify-center gap-1'>
                                        <span className='text-sm font-bold text-[#1e40af]'>
                                          {item.coachtype}
                                        </span>
                                        <span className='material-symbols-outlined text-[#1e40af]/70 text-[16px] group-hover:text-[#1e40af] transition-colors'>
                                          info
                                        </span>
                                      </div>
                                      {/* <span className="text-[10px] text-gray-500 dark:text-gray-400 uppercase tracking-wide">VIP Coach</span> */}
                                    </div>
                                  </div>
                                </>
                              )}
                              {/* <div className="info-badge"> */}
                              {/* <span className="info-badge-title">{item.coachtype}</span> */}
                              {/* <span className="info-badge-sub">Single Deck</span> */}
                              {/* </div> */}

                              {/* <div className="d-md-none" style={{ height: '1px', backgroundColor: '#eee', marginTop: '30px', width: '100%' }} /> */}

                              <div className='trip-vacancy-section tailwind-scope'>
                                {/* Mobile only arrival info */}

                                <span
                                  className='vacancy-text inline-flex items-center gap-1 mt-1 d-md-none'
                                  style={{
                                    color:
                                      item.seatavailable > 10
                                        ? '#22c55e'
                                        : '#ef4444',
                                  }}
                                >
                                  <span className='material-symbols-outlined text-sm'>
                                    event_seat
                                  </span>

                                  <span>
                                    {item.seatavailable} Seat
                                    {item.seatavailable > 1 ? 's' : ''}
                                  </span>

                                  <span>Left</span>
                                </span>
                              </div>
                            </div>

                            {/* Vacancy Section */}
                            {/* Route Visual (Desktop) */}
                            <div className='trip-vacancy-section d-none d-md-block flex flex-col'>
                              <span
                                className='vacancy-text'
                                style={{
                                  color:
                                    item.seatavailable > 10
                                      ? '#22c55e'
                                      : '#ef4444',
                                }}
                              >
                                {item.seatavailable} Seat
                                {item.seatavailable > 1 ? 's' : ''}
                              </span>

                              <div className='vacancy-sub'>Left</div>
                            </div>

                            {/* Price & Action Section */}
                            <div className='trip-price-section'>
                              <div className='price-tag'>
                                <span className='price-currency'>
                                  {monetary_unit}
                                </span>
                                {(currentCurrency === 'MYR'
                                  ? item.adultprice
                                  : item.adultpriceinsgd || 0
                                ).toFixed(2)}
                              </div>
                              {title === 'Departure' ? (
                                <button
                                  id={'button' + index}
                                  className='btn-select-trip'
                                  onClick={() =>
                                    updateSelectedDepartData(
                                      index,
                                      item.departuredate,
                                      item.coachtype,
                                      item.seatavailable,
                                      item.adultprice,
                                      item.childprice,
                                      item.tripkey,
                                      item.pickupaddress,
                                      item.dropoffaddress,
                                      item.tripduration,
                                      item.tripdurationinsecond,
                                      item.adultpriceinsgd || 0,
                                      item.childpriceinsgd || 0,

                                      item.fromplaceid,
                                      item.fromplacedisplayname,
                                      item.fromplaceuniqueshortname,
                                      item.fromsubplaceid,
                                      item.fromsubplacedisplayname,
                                      item.fromsubplacedisplayname1,
                                      item.fromsubplaceuniqueshortname,

                                      item.toplaceid,
                                      item.toplacedisplayname,
                                      item.toplaceuniqueshortname,
                                      item.tosubplaceid,
                                      item.tosubplacedisplayname,
                                      item.tosubplacedisplayname1,
                                      item.tosubplaceuniqueshortname,

                                      item.shuttlebustripkey,
                                      item.routeid,
                                      item.tripdate,
                                      item.triptime,
                                      item.tripno,
                                      item.operator,
                                      item.companyid,
                                      item.companyname,
                                      item.coachid,
                                      item.coachnumber,
                                    )
                                  }
                                >
                                  Select
                                </button>
                              ) : (
                                <button
                                  id={'button' + index}
                                  className='btn-select-trip'
                                  onClick={() =>
                                    updateSelectedReturnData(
                                      index,
                                      item.departuredate,
                                      item.coachtype,
                                      item.seatavailable,
                                      item.adultprice,
                                      item.childprice,
                                      item.tripkey,
                                      item.pickupaddress,
                                      item.dropoffaddress,
                                      item.tripduration,
                                      item.tripdurationinsecond,
                                      item.adultpriceinsgd || 0,
                                      item.childpriceinsgd || 0,

                                      item.fromplacedisplayname,
                                      item.toplacedisplayname,

                                      item.fromsubplacedisplayname,
                                      item.tosubplacedisplayname,
                                      item.routeid,
                                      item.tripdate,
                                      item.triptime,
                                      item.tripno,
                                      item.operator,
                                      item.companyid,
                                      item.companyname,
                                      item.coachid,
                                      item.coachnumber,
                                    )
                                  }
                                >
                                  Select
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
};
